var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWidgetsV3Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 3.5C0.5 1.84315 1.84315 0.5 3.5 0.5H20.5C22.1569 0.5 23.5 1.84315 23.5 3.5V20.5C23.5 22.1569 22.1569 23.5 20.5 23.5H3.5C1.84315 23.5 0.5 22.1569 0.5 20.5V3.5ZM2.5 9V20.5C2.5 21.0523 2.94772 21.5 3.5 21.5H15L15 9H2.5ZM2.5 7V3.5C2.5 2.94772 2.94772 2.5 3.5 2.5H20.5C21.0523 2.5 21.5 2.94772 21.5 3.5V7H2.5ZM17 9V21.5H20.5C21.0523 21.5 21.5 21.0523 21.5 20.5V9H17Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetsV3Icon);
export default __webpack_public_path__ + "static/media/widgets-v3-icon.492ec16201b26159ed6d2cc5e72239f9.svg";
export { ForwardRef as ReactComponent };